import { render, staticRenderFns } from "./ArrayValue.vue?vue&type=template&id=15c2cde7&scoped=true"
import script from "./ArrayValue.vue?vue&type=script&lang=js"
export * from "./ArrayValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c2cde7",
  null
  
)

export default component.exports